import * as React from 'react';

type ActionLayoutProps = {
    children: React.ReactNode;
};

export const ActionLayout = ({ children }: ActionLayoutProps) => {
    return (
        <div className='actionLayout' 
            style={{ 
                display: 'flex', 
                flexDirection: 'row',
                justifyContent: 'flex-end',
                gap: '8px' }}>
            {children}
        </div>
    )
}